import React from 'react';

const ServicesOneABoutSurgicalOncology = () => {
   return (
      <>
         <section className="about-area pt-120 pb-90">
            <div className="container">
               <div className="row ">
                  <div className="col-xl-6 col-lg-6 col-md-12">
                     <div className="section-title section-title-m-0 pos-rel mb-50 text-end">
                        <div className="section-icon">
                           <img className="section-back-icon back-icon-right" src="img/section/section-back-icon.png" alt="" />
                        </div>
                        <div className="section-text section-text-small pos-rel">
                           <h5>health care facility</h5>
                           <h1>Would you rather stay at home than go into a health care facility?</h1>
                        </div>
                     </div>
                  </div>
                  <div className="col-xl-6 col-lg-6 col-md-12">
                     <div className="facalty-text mb-50">
                        <p>
                           The Surgical oncology department at Octavia is established with a vision of being a one stop destination for solution to all cancer patient.
                           <br />
                           Our Highly experienced & trained Oncologist work in co- ordination across departments and specialties to provide supreme care to the patient.
                           <br />
                           With high end technologies, our surgeon leaves no stone unturned to make sure that they are giving our patients the best possible treatment available anywhere in the world. The cancer care system at Octavia involves surgery for Head and Neck, Stomach colon rectum cancer, Pancreas cancer, Gallbladder cancer, Liver Cancer, Lung cancer, Breast cancer, Ovarian cancer, Cervix cancer, Skin Cancer etc.
                           <br />
                           The mission is to take the fight against cancer to the next frontier and redefine clinical benchmarks and outcomes.
                        </p>
                     </div>
                  </div>
               </div>
               {/* <div className="row">
                  <HomeSIngleService icon="1" title="Body Surgery" border_className="service-box-border" />
                  <HomeSIngleService icon="2" title="Dental Care" border_className="service-box-border" />
                  <HomeSIngleService icon="3" title="service-content" border_className="service-box-border" />
                  <HomeSIngleService icon="4" title="Blood Cancer" border_className="service-box-border" />
                  <HomeSIngleService icon="5" title="Neurology Sargery" border_className="service-box-border" />
                  <HomeSIngleService icon="6" title="Allergic Issue" border_className="service-box-border" />
               </div> */}
            </div>
         </section>
      </>
   );
};

export default ServicesOneABoutSurgicalOncology;